/*
 * @Author: Jason
 * @Date: 2025-06-20 09:08:09
 * @LastEditors: Jason
 * @LastEditTime: 2025-06-26 17:32:58
 * @FilePath: /MSFinWeb/public/ccm.js
 * @Description:
 *
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved.
 */
class ConfigManager {
  static instance = null
  config = null
  initialized = false

  static getInstance() {
    if (!ConfigManager.instance) {
      ConfigManager.instance = new ConfigManager()
    }
    return ConfigManager.instance
  }

  async loadConfig() {
    //if (this.initialized) return this.config;

    try {
      // 先尝试从 localStorage 获取配置
      //const storedConfig = this.getStoredConfig();
      //if (storedConfig) {
      //    this.config = storedConfig;
      //    this.initialized = true;
      //    return this.config;
      //}

      // 如果没有存储的配置，从 config.json 加载
      const response = await fetch('/config.json', {
        cache: 'no-store', // 完全禁用缓存，每次请求都向服务器获取最新内容
      })
      const config = await response.json()

      // 保存到 localStorage
      this.saveConfig(config)
      this.initialized = true
      return this.config
    } catch (error) {
      console.error('Failed to load config:', error)
      return null
    }
  }

  // 同步获取配置的方法
  getConfig() {
    if (!this.initialized) {
      // 如果配置未初始化，尝试从 localStorage 获取
      const storedConfig = this.getStoredConfig()
      if (storedConfig) {
        this.config = storedConfig
        this.initialized = true
      }
    }
    return this.config
  }

  getStoredConfig() {
    const url = localStorage.getItem('ApiUri')
    const port = localStorage.getItem('ApiPort')
    const httpsPort = localStorage.getItem('ApiPortHttps')

    if (!url || !port) return null

    // 读取其他配置
    const isSecond = localStorage.getItem('isSecond')
    const isNewPlayer = localStorage.getItem('isNewPlayer')
    const videoServer = localStorage.getItem('videoServer')
    const dvrServer = localStorage.getItem('dvrServer')
    const features = localStorage.getItem('features')

    return {
      url,
      port,
      httpsPort,
      isSecond,
      isNewPlayer,
      videoServer: videoServer ? JSON.parse(videoServer) : undefined,
      dvrServer: dvrServer ? JSON.parse(dvrServer) : undefined,
      features: features ? JSON.parse(features) : undefined,
    }
  }

  saveConfig(config) {
    localStorage.setItem('ApiUri', config.url)
    localStorage.setItem('ApiPort', config.port)
    localStorage.setItem('ApiPortHttps', config.httpsPort)
    localStorage.setItem('isSecond', config.isSecond)
    localStorage.setItem('isNewPlayer', config.isNewPlayer)
    localStorage.setItem('videoServer', JSON.stringify(config.videoServer))
    localStorage.setItem('dvrServer', JSON.stringify(config.dvrServer))
    // 保存 features 配置
    if (config.features) {
      localStorage.setItem('features', JSON.stringify(config.features))
    }
    // 保存完整配置到内存
    this.config = config
  }

  getApiUrl() {
    const config = this.getConfig()
    if (!config) return null

    const protocol = window.location.protocol
    var port = protocol === 'https:' ? config.httpsPort : config.port

    return `${protocol}//${window.location.hostname}:${port}`
  }
}

window.ConfigManager = ConfigManager.getInstance()
